import { IELTFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { IELTPopulatedData } from 'legacy/lut/classes/models/partner360/ELT/IELTPopulatedData'

import { Nullable } from 'clickNgo/models/utils'

import { initialLastEngagement } from '../ui/meetingReview/lastEngagement/config'

export const getLastELTEngagement = (
  formData: Nullable<IELTFormData>,
  populatedData: Nullable<IELTPopulatedData>
) => {
  if (formData?.LastEngagement && formData.LastEngagement.length > 0) {
    return formData?.LastEngagement
  }

  if (populatedData?.LastELTEngagement && JSON.parse(populatedData.LastELTEngagement).length > 0) {
    return JSON.parse(populatedData.LastELTEngagement)
  }

  return initialLastEngagement
}
